
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Award } from 'lucide-react';
import { Badge } from "@/components/ui/badge";
import { CommentType } from '@/components/reader-home/types';

interface FeaturedDiscussionsProps {
  comments: CommentType[];
}

const FeaturedDiscussions: React.FC<FeaturedDiscussionsProps> = ({ comments }) => {
  if (comments.length === 0) return null;

  return (
    <div className="mb-8 bg-accent/40 rounded-lg p-4">
      <h4 className="font-semibold flex items-center mb-4">
        <Award className="h-4 w-4 mr-2 text-amber-500" />
        Featured Discussions
      </h4>
      <div className="space-y-4">
        {comments.slice(0, 2).map(comment => (
          <div key={comment.id} className="bg-background/50 rounded p-3">
            <div className="flex items-center mb-2">
              <Avatar className="h-6 w-6 mr-2">
                <AvatarImage src={comment.user.avatar} alt={comment.user.name} />
                <AvatarFallback>{comment.user.name.substring(0, 2)}</AvatarFallback>
              </Avatar>
              <span className="font-medium text-sm">{comment.user.name}</span>
              {comment.user.isJournalist && (
                <Badge variant="outline" className="ml-2 bg-primary/10 text-primary text-xs">
                  Journalist
                </Badge>
              )}
            </div>
            <p className="text-sm line-clamp-2">{comment.content}</p>
            <div className="text-xs text-muted-foreground mt-2">
              {comment.likes} likes · {comment.replies?.length || 0} replies
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturedDiscussions;
